export { ConfirmModal, Modal } from './Modal'
export type { ConfirmModalProps, ModalOnClose, ModalProps } from './Modal.types'
